<template>
  <div v-if="getPermission.do.view || getPermission.doReadOnly.view">

    <md-tabs md-sync-route class="do-tab">
      <md-tab id="tab-do-header" md-label="Header" to="/do/headers"></md-tab>
      <md-tab id="tab-do-item" md-label="Item" to="/do/items"></md-tab>
      
    </md-tabs>
    <router-view/>
  </div>
</template>

<style lang="scss">
  .do-tab {
    .md-tabs-navigation {
      .md-theme-default {
        height: 25px;
      }
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  


  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>
